<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import CustomList from "../../compositions/CustomList.vue";
import CustomEvent from "../../compositions/CustomEvent.vue";
import config from "../../config.js";
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    popups:{
      type:Array,
      default: () => {
        return [];
      }
    }
})

const listRef = ref();
const isListShow = ref(false);
const isLoading = ref(false);
const isShowDialog = ref(false);
const itemIndex = ref(-1);
const unreadCount = ref(0);
const listEof = ref(false);
const listAllCount = ref(0);
const notifyDetail = reactive({
  title:'',
  expired_from:'',
  content:'',
  is_readed:false,
  notification_type:0,
});

const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
    listEof.value = eof;
    notifyDetail.title = value.title;
    notifyDetail.expired_from = value.expired_from;
    notifyDetail.content = value.content;
    notifyDetail.is_readed = (value.to_users.length > 0 ? true : false);
    notifyDetail.notification_type = value.notification_type;
    //未読の場合は既読に変更
    if (notifyDetail.is_readed == false) {
      addReaded(value.id);
    }
  }
}
const isPopupDialog = ref(false);
const showPopup = () => {
  isPopupDialog.value = true;
}
const closePopup = () => {
  isPopupDialog.value = false;
}

const closeDialog = () => {
  isClosing.value = true;
  isShowDialog.value = false;
}
const showDialog = (index:int) => {
  itemIndex.value = index;
  isShowDialog.value = true;
}
const nextNotifyDetail = () => {
  if (listEof.value) {
    return;
  }
  if ((listAllCount.value-1) <= itemIndex.value) {
    return;
  }
  itemIndex.value++;
}
const prevNotifyDetail = (index:int) => {
  if (itemIndex.value == 0) {
    return;
  }
  itemIndex.value--;
}

const notifyClick = () => {
  isListShow.value = !isListShow.value;
}
const notifyClose = () => {
  if (isShowDialog.value == true) {
    return;
  }
  isListShow.value = false;
}
const addReaded = async(id) => {
  let params = new FormData();
  params.append('id', id);
  const response = await axios(props.apis.notification_readed,{method:"post",data:params});
  if (response.data.status == 200) {
    listRef.value.updateItem(response.data.data);
    getUnreadCount();
  }
}
const getUnreadCount = async() => {
    const response = await axios.get(props.apis.notification_unread_count);
    unreadCount.value = response.data.count;
}
const notifyReset = () => {
  isClosing.value = true;
}
const domComplete = () => {
  listAllCount.value = listRef.value.getItemAllCount();
}
const {element,isClosing,clickOutside} = CustomEvent(notifyClose)

onBeforeUnmount(() => {
  window.removeEventListener('click', clickOutside);
});
onMounted(() => {
  window.addEventListener('click', clickOutside);
  getUnreadCount();
  if (props.popups.length > 0) {
    showPopup();
  }
});
</script>

<style scoped>
</style>
<template>
<div ref="element">
  <!-- Notifications -->
  <button type="button" data-dropdown-toggle="notification-dropdown" class="inline-flex relative items-center p-2 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100" @click="notifyClick">
    <span class="sr-only">通知を見る</span>
    <!-- Bell icon -->
    <img class="w-6 h-6" src="../../../public/images/icon/btn_notice.svg" alt="notice">
    <div v-show="unreadCount > 0" class="inline-flex absolute -top-1 -right-1 justify-center items-center w-6 h-6 text-xs font-bold text-white bg-orange-500 rounded-full border-2 border-white dark:border-gray-900">{{ unreadCount }}</div>
  </button>
  <!-- Dropdown menu -->
  <div v-show="isListShow" class="absolute mb-4 max-w-sm text-base list-none bg-white rounded divide-y divide-gray-100 shadow-lg">
    <custom-list
      ref="listRef"
      :api-url="apis.notification_list"
      :reset="notifyReset"
      :item-index="itemIndex"
      :handler="handler"
      :dom-complete="domComplete"
    >
    <template v-slot:item="slotProps">
      <div @click="showDialog(slotProps.index)">
        <span v-show="slotProps.item.to_users.length == 0" class="rounded bg-orange-500 text-white px-2 mr-1">未読</span> 
        <span v-show="slotProps.item.notification_type == config.NOTIFICATION_TYPES['重要']" class="rounded bg-blue-700 text-white px-2">重要</span> 
        <span v-show="slotProps.item.notification_type == config.NOTIFICATION_TYPES['緊急']" class="rounded bg-red-700 text-white px-2">緊急</span> 
        {{ slotProps.item.title }}
      </div>
    </template>
    </custom-list>
  </div>
  <modal-dialog
    :is-visible="isShowDialog"
    :close="closeDialog"
    :is-loading="isLoading"
    width="60%"
  >
    <template v-slot:header>
      お知らせ
    </template>
    <template v-slot:default>
    <div class="w-full mb-6 p-6 flex items-center relative">
      <a href="javascript:void(0)" @click="prevNotifyDetail" class="text-3xl text-gray-500 absolute top-1/2 left-0"><i class="fa-solid fa-caret-left"></i></a>
      <div>
        <span v-show="notifyDetail.notification_type == config.NOTIFICATION_TYPES['重要']" class="rounded bg-blue-700 text-white px-2">重要</span> 
        <span v-show="notifyDetail.notification_type == config.NOTIFICATION_TYPES['緊急']" class="rounded bg-red-700 text-white px-2">緊急</span> 
        <div>{{ notifyDetail.expired_from }}</div>
        <div>{{ notifyDetail.title }}</div>
        <div class="crlf-area">{{ notifyDetail.content }}</div>
      </div>
      <a href="javascript:void(0)" @click="nextNotifyDetail" class="text-3xl text-gray-500 absolute top-1/2 right-0"><i class="fa-solid fa-caret-right"></i></a>
    </div>
  </template>
  </modal-dialog>
  <modal-dialog
    :is-visible="isPopupDialog"
    :close="closePopup"
    width="60%"
  >
    <template v-slot:header>
      重要なお知らせ
    </template>
    <template v-slot:default>
    <div class="w-full mb-6 p-6 flex flex-col items-center relative">
      <div v-for="popupData in popups" :key="popupData.id" class="w-full border-b border-color-gray-500 mb-2">
        <span v-show="popupData.notification_type == config.NOTIFICATION_TYPES['重要']" class="rounded bg-blue-700 text-white px-2">重要</span> 
        <span v-show="popupData.notification_type == config.NOTIFICATION_TYPES['緊急']" class="rounded bg-red-700 text-white px-2">緊急</span> 
        <div>{{ popupData.expired_from }}</div>
        <div>{{ popupData.title }}</div>
        <div class="crlf-area">{{ popupData.content }}</div>
      </div>
    </div>
  </template>
  </modal-dialog>
</div>
</template>

